if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	(function addStylesToDom(element) {
	  window.disco = window.disco || {};

	  // this function is saved to the window object and is called by the application code
	  // in order to reduce code duplication and errors.  since this file is not
	  // processed by webpack, the code here can't easily live in a common module
	  // that can be imported where needed
	  window.disco._addStyleElement =
	    window.disco._addStyleElement ||
	    function (styleElement, injectionPoint) {
	      // helper to check if root is defined before injecting element
	      function inject(el, root) {
	        if (root && el) {
	          root.appendChild(el);
	        }
	      }
	      const installedStyles = window.disco._installedStyles || [];
	      const isAlreadyInstalled = installedStyles.indexOf(styleElement) >= 0;

	      const injectionPoints = Array.isArray(injectionPoint)
	        ? injectionPoint
	        : injectionPoint instanceof NodeList ||
	          injectionPoint instanceof HTMLCollection
	        ? Array.from(injectionPoint)
	        : [injectionPoint];

	      if (
	        (styleElement.href &&
	          styleElement.href.toLowerCase().includes('font')) ||
	        window.STORYBOOK_ENV !== undefined ||
	        (styleElement.tagName !== 'STYLE' && styleElement.tagName !== 'LINK')
	      ) {
	        document.head.appendChild(styleElement);
	      } else {
	        if (injectionPoints.length === 0) return;

	        if (styleElement.tagName === 'LINK') {
	          // links can just be cloned and added to the dom. the original styleElement
	          // can only be added to the dom once, after which clones will have to be used
	          let copy = !isAlreadyInstalled
	            ? styleElement
	            : styleElement.cloneNode(true);

	          for (const ip of injectionPoints) {
	            inject(copy, ip.shadowRoot);
	            copy = styleElement.cloneNode(true);
	          }
	        } else {
	          // element is a style tag.  MutationObservers need to be setup to propagate
	          // changes from the original element to all clones as styles seem to be added
	          // to the tags asynchronously. the tags are initially empty

	          const nClones = isAlreadyInstalled
	            ? injectionPoints.length
	            : injectionPoints.length - 1;
	          const clones = Array(nClones)
	            .fill(0)
	            .map(() => styleElement.cloneNode(true));

	          if (clones.length > 0) {
	            const observer = new MutationObserver(() => {
	              clones.forEach((clone) => {
	                clone.textContent = styleElement.textContent;
	              });
	            });
	            observer.observe(styleElement, { childList: true });
	          }

	          for (let i = 0, j = 0; i < injectionPoints.length; i += 1) {
	            if (i === 0 && !isAlreadyInstalled) {
	              inject(styleElement, injectionPoints[i].shadowRoot);
	            } else {
	              inject(clones[j], injectionPoints[i].shadowRoot);
	              j += 1;
	            }
	          }
	        }
	      }
	    };

	  const injectionPoints =
	    (window && window.disco && window.disco._injectionPoints) ||
	    document.querySelectorAll('.disco-widget');

	  window.disco._addStyleElement(element, injectionPoints);

	  window.disco._installedStyles = window.disco._installedStyles || [];
	  window.disco._installedStyles.push(element);
	})(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	4303: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"76":1,"311":1,"1296":1,"1405":1,"1727":1,"1882":1,"1981":1,"2076":1,"2249":1,"2476":1,"2487":1,"2491":1,"2756":1,"3202":1,"3416":1,"3491":1,"3590":1,"3739":1,"3853":1,"4128":1,"4170":1,"4218":1,"4387":1,"4412":1,"4683":1,"4924":1,"5063":1,"5080":1,"5185":1,"5204":1,"5360":1,"5437":1,"5524":1,"5628":1,"5917":1,"6258":1,"6511":1,"6562":1,"6612":1,"6670":1,"6730":1,"6751":1,"7079":1,"7309":1,"7423":1,"8033":1,"8073":1,"8183":1,"8546":1,"8554":1,"8764":1,"8913":1,"9227":1,"9265":1,"9477":1,"9530":1,"9674":1,"9680":1,"9941":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr